import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { EntityType } from '@frontend/common';
import { RoleExtendedListResponse, RoleQueryParams } from '@frontend/role/types';

export class RoleExtendedClient extends APIClient {
    public static readonly endpoint = '/authorization-api/ext/v1';

    public static async fetchEntityRolesExtended(
        accountId: string,
        entityType: EntityType,
        entityId: string,
        queryParams?: ApiQueryParams<RoleQueryParams>
    ): Promise<RoleExtendedListResponse> {
        return await this.apiPaginated<RoleExtendedListResponse, RoleQueryParams>(
            `${this.endpoint}/accounts/${accountId}/${entityType}s/${entityId}/roles`,
            queryParams
        );
    }
}
